import Choice from "../../components/choice";

const Home = () => <Choice />;

export default Home;
